import GroupedGroup from './grouped-group';
import GroupedMenu from './grouped-menu';

export default {
  Group: GroupedGroup,
  Menu: GroupedMenu,
  GroupHeading: () => null, // in this implementation heading should return null
};
